import { render, staticRenderFns } from "./UploadedFilesList.vue?vue&type=template&id=51086877&"
import script from "./UploadedFilesList.vue?vue&type=script&lang=js&"
export * from "./UploadedFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports